// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__1hjR6","title":"Item_title__2h1kA","container":"Item_container__1_r2B"};